import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconOperationType = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 512 512" size={size}>
      <title>
      </title>
      <g>
        <path d="M342.5854,188.8854a25.2761,25.2761,0,0,0-17.8867,43.1582c9.5742,9.5649,26.2364,9.5649,35.7549,0h.0093a25.2807,25.2807,0,0,0-17.8775-43.1582Z">
        </path>
        <path d="M468.2842,180.8234,330.98,43.5094c-17.8125-17.8311-48.9009-17.8311-66.6948,0L156.9365,150.8575a47.1916,47.1916,0,0,0,0,66.6763L213.51,274.1071l-20.7766,20.7766L178.5991,280.75a17.0892,17.0892,0,0,0-24.1767,0L45.7754,389.3966a54.18,54.18,0,0,0,76.6216,76.6216l108.6469-108.647a17.0892,17.0892,0,0,0,0-24.1767L216.91,319.06l20.7766-20.7766L294.26,354.8571a47.18,47.18,0,0,0,66.6762,0L468.2842,247.5A47.1915,47.1915,0,0,0,468.2842,180.8234ZM254.8427,204.3461a28.5,28.5,0,1,1,0-40.3055A28.4953,28.4953,0,0,1,254.8427,204.3461ZM384.6489,256.22a59.4867,59.4867,0,1,1-.0093-84.1176A59.0856,59.0856,0,0,1,384.6489,256.22Z">
        </path>
      </g>
    </BaseIcon>
  );
}

export default IconOperationType;
